import React, { useEffect } from "react";
import { Table, Space, Switch, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useItemModel } from "../itemModel";
import { IItemDetail } from "../itemType";
import useGlobalModel from "@/model/globalModel";
import useNavModel from "@/model/navModel";
import { tableSize } from "@/utils/constants";
import YhTootip from "@/components/YhTootip";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, onDisabled
    } = useItemModel();
    const { selectedNavId, replaceNav } = useNavModel();
    const onLook = (itemCode: string) => {
        let supplierEditKey = "13-6-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: itemCode, mode: "look", },
            true
        );
    }
    const columns: ColumnsType<IItemDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (text, record, index) => `${index + 1}`
        }, {
            title: '项目编码',
            width: 160,
            dataIndex: 'itemCode',
            // render: (text: any,record:any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={(e) => {e.stopPropagation();onLook(record.id)}}>{text}</p></Tooltip>,
            render: (text: any, record: any) => <YhTootip text={text} onClick={(e) => onLook(record.id)} />,
        }, {
            title: '项目名称',
            width: 180,
            dataIndex: 'itemName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '品牌',
            width: 180,
            dataIndex: 'brandName',
            render: (text: any) => <YhTootip text={text} style={{ width: '300px !important' }} />,
        }, {
            title: '工时',
            width: 80,
            dataIndex: 'itemWorkHours',
        }, {
            title: '单价',
            width: 80,
            dataIndex: 'workHoursPrice',
        }, {
            title: '工时费',
            width: 80,
            dataIndex: 'itemAmount',
        }, {
            title: '创建人',
            width: 120,
            dataIndex: 'createUser',
        }, {
            title: '创建时间',
            width: 150,
            dataIndex: 'createTime',
        }, {
            title: '备注',
            width: 150,
            dataIndex: 'remark',
        }, {
            title: '操作',
            width: 160,
            dataIndex: 'enable',
            render: (text, record) => (
                <Space size="middle">
                    {/* checked={record.materialStatus == 0} */}
                    <Switch checked={text == 1} onChange={(checked) => {
                        // onDisabled(record.id as string, checked);
                        onDisabled(record.id as string, checked);
                        // cutDisabled(record,checked)
                    }} />
                </Space>
            ),
        }
    ];
    useEffect(() => {
        loadData()
    }, []);

    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            rowKey={record => record.id as string}
            size={tableSize}
            rowSelection={{
                selectedRowKeys: selectedRowKeys, //记录选中
                onChange: (selectedRowKeys: React.Key[], selectedRows: IItemDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                }
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id as string),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id as string]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 340px)" }}
        />
    )
}
